/**
 * App-specific sessionStorage keys.
 * Centralized so we can clear them on login/logout to avoid leaking state between users or sessions.
 */

export const NEWS_PREVIEW_SCROLL_KEY = "newsPreviewTab_scrollY";
export const SWIMMERS_PREVIEW_SCROLL_KEY = "swimmersPreviewTab_scrollY";

const APP_SESSION_KEYS: string[] = [
  NEWS_PREVIEW_SCROLL_KEY,
  SWIMMERS_PREVIEW_SCROLL_KEY,
];

/**
 * Prefix for tab-specific query params (filters, page, pageSize).
 * Keys are "tabParams_banistas", "tabParams_novedades", etc. Cleared on login/logout.
 */
export const TAB_PARAMS_PREFIX = "tabParams_";

/**
 * Removes all app-defined sessionStorage keys.
 * Call on login and logout to prevent undesired behavior (e.g. restoring scroll from another user).
 */
export function clearAppSessionStorage(): void {
  try {
    APP_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
    // Clear all tab params (tabParams_*)
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(TAB_PARAMS_PREFIX)) keysToRemove.push(key);
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // ignore storage errors (e.g. private mode)
  }
}
